const caregivers = {
  tabs: {
    history: 'Historia',
    information: 'Información',
  },

  headerButtons: {
    create: {
      createBtn: 'Crear',
    },
  },

  modal: {
    header: 'Cambiar estado',
    body: '¿Está seguro de que desea cambiar el estado padre a ',
  },

  edit: {
    tabs: {
      information: 'Información',
      linkStudent: 'Vincular Alumno',
      history: 'Historia',
      bookingHistory: 'Historial de reservas',
    },
  },

  table: {
    statuses: {
      active: 'Activo',
      inactive: 'Inactiva',
    },

    header: {
      createBtn: 'Crear',
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Telefono',
      status: 'estado',
      address: 'Dirección',
      createdBy: 'Creado por',
      createdAt: 'Creado en',
    },
  },
  form: {
    header: {
      create: {
        title: 'Crear',
      },

      update: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    actions: {
      header: 'Acciones',
      buttons: {
        resetPassword: 'Restablecer contraseña',
      },
    },

    create: {
      toasts: {
        success: 'Cuidador creado correctamente',
        error: 'Ocurrió un error al crear el padre',
      },
    },
    update: {
      formTabs: {
        informationTab: 'Información',
        notesTab: 'Notas',
        historyTab: 'Historia',
      },

      activeStatus: {
        statusActive: 'Activo',
        statusDeactivate: 'Inactiva',
      },

      suspend: {
        actionActivate: 'Reactivar',
        actionDeactivate: 'Suspender',
        suspendModal: {
          popupTitleDeactivation: 'Suspender pasajero',
          popupTitleActive: 'Suspender Motivo',
          popupTitleUnsuspend: 'Motivo de remover suspensión',
          popupSubTitleDeactivation: 'Selecciona el motivo de la suspensión',
          popupActionActive: 'Reactivar pasajero',
          popupActionDeactivate: 'Suspender pasajero',
        },
      },
      toasts: {
        success: 'Padre actualizado correctamente',
        error: 'Ocurrió un error al actualizar el padre',
        fetchError: 'Algo salió mal, inténtelo de nuevo.',
      },
    },
    sections: {
      groups: {
        header: 'Sitio y perfil',
        fields: {
          profile: {
            label: 'Perfil',
          },
        },
      },
      personalDetails: {
        header: 'Detalles personales',
        fields: {
          firstName: {
            label: 'Nombre',
          },
          lastName: {
            label: 'Apellido',
          },
          email: {
            label: 'Correo electrónico',
          },
          phone: {
            label: 'Telefono',
          },
          additionalPhone: {
            label: 'Teléfono adicional',
          },
          mainAdddres: {
            label: 'Dirección',
          },
          schoolAddres: {
            label: 'La escuela',
          },
        },
      },
      linkAttendant: {
        header: 'Alumnos',
        add: 'Añadir',
        entity: 'Alumnos',
      },
    },
  },

  attendantsTable: {
    headers: {
      name: 'Nombre',
      address: 'Dirección',
      phone: 'Telefono',
      email: 'Correo electrónico',
    },
  },
};

export default caregivers;
